import { friendlyRange } from "./compare/headlineTotals";
import { Calendar } from "lucide-react";

export const SectionReportHeader = ({ 
  clientName, 
  platformLabel, 
  reportTitle, 
  reportStart, 
  reportEnd, 
  icon, 
  iconBgClass, 
  accentColor,
  rightContent
}) => {
  const hasDateRange = reportStart && reportEnd;

  return (
    <div className="flex items-center gap-4 mb-2" data-testid={`report-header-${platformLabel.toLowerCase().replace(/\s+/g, '-')}`}>
      <div className={`w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 ${iconBgClass}`}>
        {icon}
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-white text-xl font-bold leading-tight">
          {clientName ? `${clientName}${/s$/i.test(clientName) ? "'" : "'s"} ` : 'Your '}{reportTitle}
        </p>
        {hasDateRange && (
          <div className="flex items-center gap-1.5 mt-1">
            <Calendar className="w-3.5 h-3.5 flex-shrink-0" style={{ color: accentColor }} />
            <p className="text-sm font-medium" style={{ color: accentColor }}>
              {friendlyRange(reportStart, reportEnd)}
            </p>
          </div>
        )}
      </div>
      {rightContent && (
        <div
          className="flex-shrink-0"
          onClick={(e) => e.stopPropagation()}
          onKeyDown={(e) => e.stopPropagation()}
        >
          {rightContent}
        </div>
      )}
    </div>
  );
};
